import React, { useEffect, useState } from "react";

const PageHeader = props => {

    const [hasCTAText, setHasCTAText] = useState(false);
    const [hasButtonText, setHasButtonText] = useState(false);
    const [isPhoneNumber, setIsPhoneNumber] = useState(false);

    useEffect(() => {
        setHasCTAText(!!props.ctaText);
        setHasButtonText(!!props.buttonText);
        setIsPhoneNumber(props.buttonLink.startsWith("tel:"));
    }, [props.ctaText, props.buttonText, props.buttonLink]);

    return (
        <div className="component__page-header">
            <a href={props.logoLink} target="_blank">
                <img src={props.logo} alt="Logo" />
            </a>

            <div className="page-header__cta">
                {hasCTAText && <p>{props.ctaText}</p>}

                {hasButtonText &&
                    <a href={props.buttonLink}>
                        <button><span className="page-header__button-inner">{props.buttonText}</span></button>
                    </a>
                }

            </div>
        </div >
    );
};

export default PageHeader;